import React, { useState } from 'react';
import { Container, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Formik } from 'formik';
import * as Yup from 'yup';
import '../assets/css/LoginPage.css';
import { FaGraduationCap, FaClipboardCheck, FaUsers, FaCalendarAlt } from 'react-icons/fa';

const Login = () => {
  const { login } = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .email('Email tidak valid')
      .required('Email wajib diisi'),
    password: Yup.string()
      .required('Password wajib diisi')
      .min(6, 'Password minimal 6 karakter')
  });

  const handleSubmit = async (values) => {
    try {
      console.log('Login attempt started');
      setError('');
      setLoading(true);
      
      console.log('Calling login function with:', values.email);
      const result = await login(values.email, values.password);
      console.log('Login result:', result);
      
      if (!result.success) {
        console.error('Login failed:', result.error);
        throw new Error(result.error);
      }
      
      console.log('Login successful, navigating to dashboard');
      navigate('/dashboard');
    } catch (error) {
      console.error('Login error caught:', error);
      setError(error?.message || error || 'Terjadi kesalahan saat login');
    } finally {
      console.log('Login process completed');
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container>
        <div className="login-container">
          <div className="login-info">
            <h1>Sistem Tugas Akhir Rekayasa Kosmetik</h1>
            <p>
              Platform terintegrasi untuk pengelolaan tugas akhir mahasiswa Program Studi Rekayasa Kosmetik Institut Teknologi Sumatera.
            </p>
            
            <div className="features-list">
              <div className="feature-item">
                <FaGraduationCap className="feature-icon" />
                <div className="feature-text">Pendaftaran dan pengelolaan tugas akhir</div>
              </div>
              <div className="feature-item">
                <FaClipboardCheck className="feature-icon" />
                <div className="feature-text">Proses bimbingan yang terstruktur</div>
              </div>
              <div className="feature-item">
                <FaCalendarAlt className="feature-icon" />
                <div className="feature-text">Penjadwalan seminar dan sidang</div>
              </div>
              <div className="feature-item">
                <FaUsers className="feature-icon" />
                <div className="feature-text">Kolaborasi antara mahasiswa dan dosen</div>
              </div>
            </div>
          </div>
          
          <div className="login-form">
            <img src="/logo-rekos.png" alt="Logo Rekayasa Kosmetik" className="login-logo" />
            <h2 className="login-title">Login Akun</h2>
            
            {error && <Alert variant="danger">{error}</Alert>}
            
            <Formik
              initialValues={{ email: '', password: '' }}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                <Form onSubmit={handleSubmit}>
                  <Form.Group id="email" className="mb-4">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={touched.email && errors.email}
                      placeholder="Masukkan email Anda"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.email}
                    </Form.Control.Feedback>
                  </Form.Group>
                  
                  <Form.Group id="password" className="mb-4">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={touched.password && errors.password}
                      placeholder="Masukkan password Anda"
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                  </Form.Group>
                  
                  <Button 
                    disabled={loading} 
                    className="w-100 mt-4 login-btn" 
                    type="submit"
                  >
                    {loading ? 'Memproses...' : 'Login'}
                  </Button>
                  
                  <div className="login-links mt-3">
                    <Link to="/forgot-password">Lupa Password?</Link>
                  </div>
                </Form>
              )}
            </Formik>
            
            <div className="login-links mt-4">
              Belum punya akun? <Link to="/register">Daftar</Link>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Login;
